import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private isEmpresa: boolean = false;

  constructor() {}

  setIsEmpresa(value: boolean) {
    this.isEmpresa = value;
  }

  getIsEmpresa(): boolean {
    return this.isEmpresa;
  }
}
